import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class Interceptor implements HttpInterceptor {


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const providerInfo = JSON.parse(sessionStorage?.getItem('selectedProvider') || '{}');
        const facilityId = sessionStorage?.getItem('headerFacilityId') || providerInfo?.id || 0;
        const modifiedReq = req.clone({
            headers: req.headers.set('id', `0`)
                .set('name', `name`)
                .set('facilityId', `${facilityId === 'null' || facilityId === null || facilityId === undefined || facilityId === 'undefined' ? 0 : facilityId}`)
                .set('userId', `user`)
        });
        return next.handle(modifiedReq);
    }
}